// extracted by mini-css-extract-plugin
export var archivesFixed = "block-module--archives-fixed--2d1c3";
export var archivesPost = "block-module--archivesPost--f3590";
export var articleCard = "block-module--article-card--a548a";
export var authorProfile = "block-module--author-profile--010a7";
export var button = "block-module--button--18127";
export var companyProfile = "block-module--company-profile--c580f";
export var content = "block-module--content--fd1e3";
export var cta = "block-module--cta--114cf";
export var ctaInterview = "block-module--cta-interview--4257f";
export var detail = "block-module--detail--68c2f";
export var eyecatch = "block-module--eyecatch--f4dd0";
export var home = "block-module--home--6a327";
export var interviewProfile = "block-module--interview-profile--1a522";
export var linkButton = "block-module--link-button--02c04";
export var meta = "block-module--meta--d4a85";
export var news = "block-module--news--e1445";
export var post = "block-module--post--c2096";
export var postList = "block-module--postList--780ad";
export var related = "block-module--related--244c2";
export var sidebar = "block-module--sidebar--2feed";
export var snsShare = "block-module--sns-share--a6487";
export var tagList = "block-module--tagList--069ca";